import React, { useState } from 'react';
import { useApp } from '../context/AppContext';

export default function Login() {
  const { login } = useApp();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setTimeout(() => {
      const result = login(username.trim(), password.trim());
      if (!result.success) setError('Invalid credentials. Please try again.');
      setLoading(false);
    }, 400);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f4f2', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>

        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <div style={{ width: 56, height: 56, borderRadius: 4, background: '#1c1c1c', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.2rem' }}>
            <div style={{ width: 24, height: 24, border: '2px solid #c9a96e', borderRadius: 2 }} />
          </div>
          <h1 style={{ color: '#1c1c1c', fontSize: 22, fontWeight: 700, margin: 0, letterSpacing: '-0.3px', fontFamily: 'Georgia, serif' }}>Mehendi by Marjana</h1>
          <p style={{ color: '#888', marginTop: 5, fontSize: 13, letterSpacing: '0.05em', textTransform: 'uppercase' }}>Management System</p>
        </div>

        <div style={{ background: '#fff', borderRadius: 4, padding: '2rem', border: '1px solid #e8e8e8', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1.1rem' }}>
              <label style={{ display: 'block', color: '#555', fontSize: 12, marginBottom: 6, fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase' }}>Username</label>
              <input
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                placeholder="Enter username"
                required
                style={{ width: '100%', padding: '10px 12px', borderRadius: 3, border: '1px solid #ddd', color: '#1c1c1c', fontSize: 14, outline: 'none', boxSizing: 'border-box', background: '#fafafa' }}
              />
            </div>
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', color: '#555', fontSize: 12, marginBottom: 6, fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase' }}>Password / PIN</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter password or PIN"
                required
                style={{ width: '100%', padding: '10px 12px', borderRadius: 3, border: '1px solid #ddd', color: '#1c1c1c', fontSize: 14, outline: 'none', boxSizing: 'border-box', background: '#fafafa' }}
              />
            </div>
            {error && (
              <div style={{ background: '#fdf2f2', border: '1px solid #f0d0d0', borderRadius: 3, padding: '10px 12px', color: '#b94040', fontSize: 13, marginBottom: '1rem' }}>{error}</div>
            )}
            <button
              type="submit"
              disabled={loading}
              style={{ width: '100%', padding: '11px', borderRadius: 3, background: loading ? '#888' : '#1c1c1c', border: 'none', color: '#fff', fontSize: 13, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', letterSpacing: '0.05em', textTransform: 'uppercase' }}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', color: '#bbb', fontSize: 12, marginTop: '1.5rem' }}>
          Admins use admin credentials. Artists use name + PIN.
        </p>
      </div>
    </div>
  );
}
